module.exports = "/assets/data/6e2a9d7d682023af874f4bb21f87f7a4-DA12.data.json";